import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPlay,FiCalendar,FiUser,FiExternalLink}=FiIcons;

const WebinarSection=()=> {
  return (
    <section id="webinar" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="text-center mb-16"
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.6}}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Fördjupa din kunskap med{' '}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              expertwebinar
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Se mitt webinar om karriär som IT-konsult med fokus på Software Engineer och Data Engineer
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{opacity: 0,x: -50}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
          >
            <div className="bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl p-8 text-white">
              <div className="flex items-center space-x-3 mb-6">
                <SafeIcon icon={FiPlay} className="w-8 h-8" />
                <h3 className="text-2xl font-bold">Webinar: IT-Konsult Karriär</h3>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <span>Vad krävs för att lyckas som IT-konsult?</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <span>Tekniska färdigheter för Software Engineers</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <span>Data Engineering och framtiden med AI</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                  <span>Hur du blir anställd som konsult</span>
                </li>
              </ul>
              <motion.a 
                href="https://webinarkit.com/webinar/registration/69aedb5ecfcf3f3e810ef5ed" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center space-x-2 bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
              >
                <SafeIcon icon={FiExternalLink} className="w-5 h-5" />
                <span>Se webinaret</span>
              </motion.a>
            </div>
          </motion.div>

          <motion.div
            className="space-y-6"
            initial={{opacity: 0,x: 50}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
          >
            <div className="bg-gradient-to-br from-green-50 to-teal-50 p-6 rounded-xl">
              <div className="flex items-center space-x-3 mb-4">
                <SafeIcon icon={FiCalendar} className="w-6 h-6 text-green-600" />
                <h4 className="text-lg font-semibold text-gray-800">Boka personligt möte</h4>
              </div>
              <p style={{color: 'rgb(75,85,99)'}} className="text-gray-600 mb-4">
                Vill du ha personlig rådgivning om din IT-karriär? Tider utannonseras först på sociala media. Se länk nedan för att se tillgängliga tider och boka ett möte med mig.
              </p>
              <motion.a 
                href="https://tidycal.com/1wekx5e" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-green-700 transition-colors duration-200"
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
              >
                <SafeIcon icon={FiCalendar} className="w-4 h-4" />
                <span>Boka möte</span>
              </motion.a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl">
              <div className="flex items-center space-x-3 mb-4">
                <SafeIcon icon={FiUser} className="w-6 h-6 text-purple-600" />
                <h4 className="text-lg font-semibold text-gray-800">Om Jonas Jaani</h4>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">
                20+ år inom IT-konsultbranschen, teamchef och ansvarig för traineeprogram på stort IT-konsultbolag. Specialist på att utveckla software engineers och data engineers.
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-yellow-50 p-6 rounded-xl">
              <h4 className="text-lg font-semibold text-gray-800 mb-4">☕ Stöd mitt arbete</h4>
              <p className="text-gray-600 text-sm mb-4">
                Tycker du att jag skapat värde för dig? Bjud mig på en kaffe!
              </p>
              <motion.a 
                href="https://buymeacoffee.com/jonasjaani" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-flex items-center space-x-2 bg-orange-500 text-white px-4 py-2 rounded-lg font-medium hover:bg-orange-600 transition-colors duration-200"
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
              >
                <span>☕</span>
                <span>Köp en kaffe till mig</span>
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WebinarSection;